<template>
    <div id="stepLoading" class="sscw-container sscw-flex-column">
        <img class="loading-animation" src="../../../../static/Loading_RuhestandPlus-3.gif" alt="Loading" />
    </div>
</template>

<script>
import getTheme from "@/utils/theme";

export default {
    name: "ClickWizardStepLoading",
    data() {
        return {
            theme: getTheme(),
        };
    },
    mounted() {
        this.$emit("onValidation", this.validateStep());
        this.$nextTick(() => {
            window.scrollTo(0, -250);
        });
    },
    methods: {
        validateStep() {
            return false;
        },
    },
    computed: {},
    components: {},
};
</script>
<style scoped>
.loading-animation {
    width: 100%;
    margin: auto;
}

.step-image-group {
    display: flex;
    gap: 34px;
    align-items: center;
}

.flex-col {
    display: flex;
    flex-direction: column;
}

.sscw-flex-column {
    gap: 24px;
    display: flex;
    flex-direction: column;
}

.sscw-step-input-group {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 6px;
}

.mobile-img {
    margin-left: 14px;
}

.sscw-w-full {
    flex: 1;
}

@media (min-width: 1190px) {
    .sscw-step-input-group {
        width: 683px;
    }

    .sscw-step-input-label {
        margin-bottom: 26px;
    }

    .flex-row {
        display: flex;
        gap: 33px;
    }

    .sscw-step-input-box {
        max-width: 242px;
    }

    .sscw-step-input-label {
        min-width: 299px;
    }
}
</style>
